// extracted by mini-css-extract-plugin
export default {"statusBlockOpen":"sdM7vm4p3C19IZaudWtE"};